'use client'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { Heading } from '../heading/heading.tsx'
import { Icon } from '../icon/icon.tsx'
import { Text } from '../text/text.tsx'

type Props = PropsWithChildren<{
  className?: string
  complete?: boolean
  title: string
  subtitle: string
}>

export const StepComponent = ({
  children,
  className,
  complete = false,
  title,
  subtitle,
}: Props) => {
  return (
    <div className={cn('flex items-center gap-6 py-4', className)}>
      {complete ? (
        <Icon
          name="CheckCircleIcon"
          className="drop-shadow-glow-blue-light"
          color="positive"
          size="3xl"
        />
      ) : (
        <Icon name="EllipsisHorizontalCircleIcon" color="disabled" size="3xl" />
      )}

      <div className="flex gap-2 items-center justify-between w-full max-md:flex-wrap">
        <div className="flex flex-col gap-1 max-md:w-full">
          <Heading fontSize="xl" fontWeight="bold" textColor="secondary">
            {title}
          </Heading>

          <Text fontSize="sm" fontWeight="medium" textColor="tertiary">
            {subtitle}
          </Text>
        </div>

        <div>{children}</div>
      </div>
    </div>
  )
}
